import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { LegalModal } from './LegalModal';
function PrivacyContent() {
  return <>
      <p className="text-sm text-[#6B6B6B] italic" data-id="element-48">
        Última actualización: febrero 2025
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-49">
        1. Información que recopilamos
      </h3>
      <p data-id="element-50">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de facturación. No almacenamos datos de tarjetas de
        crédito; estos son procesados de forma segura por nuestro proveedor de
        pagos.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-51">
        2. Uso de la información
      </h3>
      <p data-id="element-52">Tu información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-53">
        <li data-id="element-54">Procesar y confirmar tu compra.</li>
        <li data-id="element-55">
          Enviarte el ebook y materiales asociados a tu correo electrónico.
        </li>
        <li data-id="element-56">
          Comunicarnos contigo en caso de ser necesario respecto a tu pedido.
        </li>
      </ul>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-57">
        3. Protección de datos
      </h3>
      <p data-id="element-58">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-59">
        4. Cookies
      </h3>
      <p data-id="element-60">
        Nuestro sitio puede utilizar cookies esenciales para garantizar su
        correcto funcionamiento. No utilizamos cookies de seguimiento
        publicitario ni compartimos datos con terceros con fines de marketing.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-61">
        5. Tus derechos
      </h3>
      <p data-id="element-62">
        Podés solicitar en cualquier momento el acceso, rectificación o
        eliminación de tus datos personales. Para ejercer estos derechos,
        comunicate con nosotros a través de nuestros canales oficiales.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-63">
        6. Cambios en esta política
      </h3>
      <p data-id="element-64">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta misma página con
        la fecha de última actualización.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-[#6B6B6B] italic" data-id="element-65">
        Última actualización: febrero 2025
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-66">
        1. Producto digital
      </h3>
      <p data-id="element-67">
        El producto ofrecido es un ebook en formato PDF ("Emprender con hijos
        sin perder la cabeza"). Al completar la compra, recibirás acceso
        inmediato al archivo digital a través del correo electrónico
        proporcionado.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-68">
        2. Licencia de uso
      </h3>
      <p data-id="element-69">
        Al adquirir el ebook, obtenés una licencia personal, intransferible y no
        exclusiva para uso individual. Queda prohibida la reproducción,
        distribución, reventa o compartición del contenido sin autorización
        expresa por escrito.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-70">
        3. Precios e impuestos
      </h3>
      <p data-id="element-71">
        Los precios publicados están expresados en pesos argentinos (ARS). El
        valor final puede variar según la condición fiscal del comprador y los
        impuestos locales aplicables al momento de la compra, incluyendo IVA
        (21%).
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-72">
        4. Política de reembolso
      </h3>
      <p data-id="element-73">
        Dado que se trata de un producto digital de entrega inmediata, no se
        aceptan devoluciones una vez realizada la descarga o envío del archivo.
        Si experimentás algún problema técnico con la entrega, comunicate con
        nosotros para resolverlo.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-74">
        5. Propiedad intelectual
      </h3>
      <p data-id="element-75">
        Todo el contenido del ebook, incluyendo textos, gráficos, diseños y
        metodologías, es propiedad de Mujer Equilibrista y está protegido por
        las leyes de propiedad intelectual vigentes.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-76">
        6. Limitación de responsabilidad
      </h3>
      <p data-id="element-77">
        El contenido del ebook tiene fines informativos y educativos. Los
        resultados pueden variar según la situación individual de cada persona.
        No garantizamos resultados específicos derivados de la aplicación del
        método descrito.
      </p>

      <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#2D2D2D] !mt-6" data-id="element-78">
        7. Aceptación de los términos
      </h3>
      <p data-id="element-79">
        Al realizar la compra, aceptás estos términos y condiciones en su
        totalidad. Si no estás de acuerdo con alguno de estos puntos, te
        recomendamos no proceder con la compra.
      </p>
    </>;
}
export function Footer() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer ref={ref} className="w-full bg-[#2D2D2D] py-12 md:py-16" data-id="element-80">
        <div className="max-w-4xl mx-auto px-6" data-id="element-81">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-center" data-id="element-82">
            <p className="font-['Playfair_Display'] text-2xl md:text-3xl text-white mb-4" data-id="element-83">
              Mujer Equilibrista
            </p>

            <p className="text-[#B794C0] flex items-center justify-center gap-2 mb-6" data-id="element-84">
              Hecho con <HeartIcon className="w-4 h-4 fill-current" data-id="element-85" /> para
              madres emprendedoras
            </p>

            <div className="w-16 h-px bg-[#4A4A4A] mx-auto mb-6" data-id="element-86" />

            {/* Legal Links */}
            <div className="flex items-center justify-center gap-4 mb-6 text-sm" data-id="element-87">
              <button onClick={() => setActiveModal('privacy')} className="text-[#6B6B6B] transition-colors hover:text-[#B794C0]" data-id="element-88">
                Política de Privacidad
              </button>
              <span className="text-[#4A4A4A]" data-id="element-89">·</span>
              <button onClick={() => setActiveModal('terms')} className="text-[#6B6B6B] transition-colors hover:text-[#B794C0]" data-id="element-90">
                Términos y Condiciones
              </button>
            </div>

            <p className="text-[#6B6B6B] text-sm" data-id="element-91">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </motion.div>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-92">
        <PrivacyContent data-id="element-93" />
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-94">
        <TermsContent data-id="element-95" />
      </LegalModal>
    </>;
}